// ============================================================
// ExcelDropZone
// ------------------------------------------------------------
// กล่องลาก-วางไฟล์ Excel + ลิงก์ดาวน์โหลดไฟล์ template
// เดิม copy อยู่ 6 หน้า (Customer, Import*, Export) พร้อม state `over` ของตัวเอง
//
// มี 2 หน้าตาให้เลือกด้วย prop variant (คงดีไซน์เดิมของแต่ละหน้าไว้ทั้งคู่)
//   "modal" (ค่าเริ่มต้น) — กล่องพื้นเทาใน popup   ใช้ในหน้า Customer
//   "page"                — กล่องเส้นประเต็มหน้าจอ ใช้ในหน้า นำเข้าไฟล์ข้อมูล
//
// ใช้:
//   <ExcelDropZone
//     variant="page"
//     templateFile={excel_file}                  // ไฟล์ template (import จาก assets)
//     templateName="import_customer.xlsx"        // ชื่อไฟล์ตอนดาวน์โหลด
//     templateLabel="template นำเข้าข้อมูลลูกค้า"
//     onFile={(file) => this.readExcel(file)}    // ได้ File object ทั้งลากวางและเลือกไฟล์
//   />
// ============================================================

import React, { Component } from "react";
import { ICON } from "./icons.js";

export default class ExcelDropZone extends Component {
  state = { over: false }; // true = กำลังลากไฟล์อยู่เหนือกล่อง (เปลี่ยนสีพื้น)

  constructor(props) {
    super(props);
    this.input = React.createRef();
  }

  // ลากไฟล์มาวาง
  onDrop = (e) => {
    e.preventDefault();
    this.setState({ over: false });
    const file = e.dataTransfer.items[0]?.getAsFile();
    if (file) this.props.onFile(file);
  };

  // เลือกไฟล์จากปุ่ม — เคลียร์ค่า input ทุกครั้งเพื่อให้เลือกไฟล์เดิมซ้ำได้
  onSelect = (e) => {
    const file = e.target.files[0];
    if (file) this.props.onFile(file);
    e.target.value = "";
  };

  // event ของการลากไฟล์ (ใช้ร่วมกันทั้ง 2 หน้าตา)
  dragProps = () => ({
    onDrop: this.onDrop,
    onDragOver: (e) => {
      e.preventDefault();
      this.setState({ over: true });
    },
    onDragLeave: (e) => {
      e.preventDefault();
      this.setState({ over: false });
    },
  });

  // ลิงก์ดาวน์โหลดไฟล์ template
  renderTemplateLink = () => {
    const { templateFile, templateName, templateLabel, linkClassName = "text-primary mt-3" } = this.props;
    if (!templateFile) return null;
    return (
      <div className="w-100 text-right">
        <a className={linkClassName} href={templateFile} download={templateName}>
          <label className="icon">{ICON.excel}</label> {templateLabel}
        </a>
      </div>
    );
  };

  render() {
    const { variant = "modal" } = this.props;
    const { over } = this.state;
    const fileInput = <input className="d-none" type="file" ref={this.input} accept=".xls,.xlsx" onChange={this.onSelect} />;

    // กรอบเส้นประ ไอคอนลูกศรขึ้น (ใช้ในหน้า นำเข้าไฟล์ข้อมูล)
    const dashedBox = (
      <div className={`card py-5 border-dashed align-items-center ${over ? "bg-blue-sky" : "bg-light"}`} {...this.dragProps()}>
        <b className="icon text-primary mt-4" style={{ fontSize: 48 }}>
          {ICON.upload}
        </b>
        <b className="text-secondary">ลากและวางไฟล์ที่นี่</b>
        <small className="text-secondary mb-3">หรือ</small>
        <button className="btn btn-primary wpx-120 mb-4" onClick={() => this.input.current.click()}>
          เลือกไฟล์
        </button>
        {fileInput}
      </div>
    );

    // "page" = กล่องเส้นประพร้อมการ์ดครอบ (หน้าที่มีที่อัปโหลดที่เดียว)
    if (variant === "page") {
      return (
        <div className="card border-0 p-3 mb-3">
          {this.renderTemplateLink()}
          {dashedBox}
        </div>
      );
    }

    // "box" = ลิงก์ template + กล่องเส้นประ ไม่มีการ์ดครอบ
    // ใช้กับหน้าที่มีที่อัปโหลดหลายจุดในการ์ดเดียว (หน้าเลขมาตรปัจจุบัน + ข้อมูลน้ำ)
    if (variant === "box") {
      return (
        <>
          {this.renderTemplateLink()}
          {dashedBox}
        </>
      );
    }

    // หน้าตาแบบใน popup (หน้า Customer) — กล่องพื้นเทา ไอคอน Excel
    return (
      <div className="w-100">
        {this.renderTemplateLink()}
        <div className="p-2 text-center">
          <div className={`card p-3 ${over ? "bg-blue-sky" : "bg-contain"} border-0 text-center mb-3`} {...this.dragProps()}>
            <label className="icon text-secondary" style={{ fontSize: 48 }}>
              {ICON.excel}
            </label>
            <label className="text-secondary">ลากและวางไฟล์ที่นี่</label>
            <small className="text-secondary mb-3">หรือ</small>
            <button className="btn btn-primary" onClick={() => this.input.current.click()}>
              เลือกไฟล์
            </button>
          </div>
        </div>
        {fileInput}
      </div>
    );
  }
}
